import styled, { css } from "styled-components";
import media from "constants/media";

export const SliderStyled = styled.div`
    width: 100%;
    margin-bottom: 40px;
    padding-bottom: 50px;

    .slider {
        outline: none;
    }

    .slider-slide {
        outline: 0;
    }

    .slider-control-bottomleft,
    .slider-control-bottomright {
        ${({ noButtonsMobile }) =>
            noButtonsMobile &&
            css`
                display: none;

                ${media.mdUp`
                    display: block;
                `}
            `}

        ${({ noButtonsDesktop }) =>
            noButtonsDesktop &&
            css`
                display: block;

                ${media.mdUp`
                    display: none;
                `}
            `}
    }

    .slider-dots-container-custom {
        position: relative;

        display: flex;

        width: 95px;
        overflow: hidden;

        background: var(--color-lightGrey);
    }

    .slider-dots-dot-custom {
        display: none;
        width: 0;
        height: 0;
    }

    .paging-item {
        position: relative;

        flex: 1;
        height: 5px;

        &.active {
            &:before {
                position: absolute;
                top: 0;
                right: 0;

                width: 100px;
                height: 5px;

                background: var(--color-darkNight);

                content: "";
            }
        }
    }
`;

export const Button = styled.button`
    padding: 0;

    background: transparent;
    border: 0;
    cursor: pointer;

    transition: 0.3s all ease-in-out;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.2;
    }
`;

export const PrevIcon = styled.img`
    height: 16px;
`;

export const NextIcon = styled.img`
    height: 16px;
`;
